import {api} from '@/http'

// 职位申请-同近期投递接口
const getPositionApplyList = (data, callback, back) => {
  api('/api/delivery', 'get', data, callback, back)
}

export default {
  getPositionApplyList
}



// WEBPACK FOOTER //
// ./src/api/apply/index.js